import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const financeCategoriesList = createAsyncThunk(
  'finance/categories-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const financeCategoryStore = createAsyncThunk(
  'finance/category-store',
  async (categoryData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-finance-category/store`, categoryData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const financeCategoryEdit = createAsyncThunk(
  'finance/category-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const financeCategorySwitchStatus = createAsyncThunk(
  'finance/category-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const getFinanceCategoryReport = createAsyncThunk(
  'finance/get-finance-category-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-finance-category/get-finance-category-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printFinanceCategoryReport = createAsyncThunk(
  'finance/print-finance-category-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}school-finance-category/print-finance-category-report`,
        data
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const financeSubCategoriesList = createAsyncThunk(
  'finance/sub-categories-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/sub-category-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getFinanceCategories = createAsyncThunk(
  'finance/get-categories',
  async (_, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/get-finance-categories`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const financeSubCategoryStore = createAsyncThunk(
  'finance/sub-category-store',
  async (subCategoryData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-finance-category/sub-category-store`, subCategoryData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const financeSubCategoryEdit = createAsyncThunk(
  'finance/sub-category-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/sub-category-edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const financeSubCategorySwitchStatus = createAsyncThunk(
  'finance/sub-category-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-finance-category/sub-category-switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

type ToolsState = {
  errors: any
}

const initialState: ToolsState = {
  errors: '',
}

export const financeCategorySlice = createSlice({
  name: 'finance-category',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(financeCategoryStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(financeSubCategoryStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = financeCategorySlice.actions
export default financeCategorySlice.reducer
